import { createApp } from 'vue'
import App from './App.vue'
import Vant from 'vant';
import {Routers} from '@/routor'
import Store from '@/store/index'

import 'vant/lib/index.css';

// main.js 顶部 —— 放在 createApp 之前执行
(function bridgeWxOAuthParams() {
  var origin = window.location.origin;
  var pathname = window.location.pathname;
  var hash = window.location.hash || '#/';
  var search = window.location.search;
  if (!search) return;

  var sp = new URLSearchParams(search);
  // 只有在微信回调带 code 时才处理
  if (!sp.has('code')) return;

  // 解析现有 hash（例如 "#/test/pay?foo=1"）
  var parts = hash.slice(1).split('?'); // 去掉 "#"
  var hashPath = parts[0];
  var hashParams = new URLSearchParams(parts[1] || '');

  // 把 code/state 从 search 搬到 hash，search 的值优先生效
  ['code', 'state'].forEach(function (k) {
    var v = sp.get(k);
    if (v !== null) hashParams.set(k, v);
  });

  // 其他 search 参数若 hash 里没有，也一并搬过去（可选）
  sp.forEach(function (v, k) {
    if (k === 'code' || k === 'state') return;
    if (!hashParams.has(k)) hashParams.set(k, v);
  });

  // 重新拼装 URL：去掉 search，只保留合并后的 hash
  var newHashQuery = hashParams.toString();
  var newHash = '#' + hashPath + (newHashQuery ? '?' + newHashQuery : '');
  var newUrl = origin + pathname + newHash;

  // 防重复跳转
  if (newUrl !== window.location.href) {
    window.location.replace(newUrl);
  }
})();



createApp(App).use(Routers).use(Vant).use(Store).mount('#app')

